/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserRequest } from '../models/CreateUserRequest';
import type { GlobalUser } from '../models/GlobalUser';
import type { UpdateUserRequest } from '../models/UpdateUserRequest';
import type { User } from '../models/User';
import type { UserSettings } from '../models/UserSettings';
import type { UserSettingsMap } from '../models/UserSettingsMap';
import type { UserSettingsSearchRequest } from '../models/UserSettingsSearchRequest';
import type { UserSettingUpsertRequest } from '../models/UserSettingUpsertRequest';
import type { UserSettingUpsertResponse } from '../models/UserSettingUpsertResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * Get list of users (for user's company)
     * @returns User Success
     * @throws ApiError
     */
    public static getUsers({
        limit,
        offset,
        dataAccessGroupIds,
        roleIds,
        search,
        includeExternalDetails,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Data Access Group
         */
        dataAccessGroupIds?: Array<number>,
        /**
         * Role
         */
        roleIds?: Array<number>,
        /**
         * Search by name
         */
        search?: string,
        /**
         * Include Cognito and Quicksight details
         */
        includeExternalDetails?: boolean,
    }): CancelablePromise<Array<User>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user',
            query: {
                'limit': limit,
                'offset': offset,
                'dataAccessGroupIds': dataAccessGroupIds,
                'roleIds': roleIds,
                'search': search,
                'includeExternalDetails': includeExternalDetails,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * @returns User Success
     * @throws ApiError
     */
    public static createUser({
        requestBody,
    }: {
        requestBody: CreateUserRequest,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get current user
     * @returns User Success
     * @throws ApiError
     */
    public static getCurrentUser({
        login,
    }: {
        /**
         * flag to log audit message
         */
        login?: boolean,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/current',
            query: {
                'login': login,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update user profile
     * @returns User Success
     * @throws ApiError
     */
    public static updateCurrentUser({
        requestBody,
    }: {
        /**
         * User settings
         */
        requestBody: {
            settings?: UserSettings;
        },
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Upsert a single setting for the authenticated user
     * Upserts the authenticated user's setting for the key carried in the request body. An unknown namespace, an unregistered scope, or a value over 128 KB returns 400. For `table:{scope}` the backend does not validate the view-state shape or its version set: it requires only a JSON object within the size cap, and that the value's `v` is monotonic per key. A write that carries a `v` older than the stored row's `v` (or omits `v` over a versioned row) is rejected with 409 and a machine-readable `errorCode` — see the 409 response.
     * @returns UserSettingUpsertResponse Success
     * @throws ApiError
     */
    public static upsertUserSetting({
        requestBody,
    }: {
        requestBody: UserSettingUpsertRequest,
    }): CancelablePromise<UserSettingUpsertResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                409: `Stale view-state version — the write would move a \`table:{scope}\` row backwards. Body carries a machine-readable \`errorCode\`.`,
            },
        });
    }

    /**
     * Batch-get the authenticated user's settings by key
     * Returns a map of `{ [key]: value | null }` for the authenticated user. Keys with no stored row return null (the client treats absence as "use defaults"); nothing is ever seeded on user creation. This read uses POST so the keys travel in the request body rather than the URL — namespaced keys carry a reserved character (`:`), and URL transport is subject to encoding and intermediary (proxy/WAF) quirks.
     * @returns UserSettingsMap Success
     * @throws ApiError
     */
    public static getUserSettings({
        requestBody,
    }: {
        requestBody: UserSettingsSearchRequest,
    }): CancelablePromise<UserSettingsMap> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/settings/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Get user details
     * @returns User Success
     * @throws ApiError
     */
    public static getUser({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update user data
     * @returns User Success
     * @throws ApiError
     */
    public static updateUser({
        userId,
        requestBody,
    }: {
        userId: number,
        requestBody: UpdateUserRequest,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete User
     * @returns any Success
     * @throws ApiError
     */
    public static deleteUser({
        userId,
    }: {
        /**
         * User ID
         */
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export list of users
     * @returns binary Success
     * @throws ApiError
     */
    public static exportUsers(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * reset user password
     * @returns any Success
     * @throws ApiError
     */
    public static resetUserPassword({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/resetPassword',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Quick Sight User
     * @returns any Success
     * @throws ApiError
     */
    public static createQuickSightUser({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/quicksight',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get users quicksight status
     * @returns string Success
     * @throws ApiError
     */
    public static getUsersQuicksightStatus(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/quicksight/status',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Cognito User
     * @returns any Success
     * @throws ApiError
     */
    public static createCognitoUser({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/cognito',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update User Company
     * @returns any Success
     * @throws ApiError
     */
    public static updateUserCompany({
        id,
        requestBody,
    }: {
        /**
         * User ID
         */
        id: number,
        requestBody: {
            targetCompanyId: number;
        },
    }): CancelablePromise<{
        user?: GlobalUser;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/user/{id}/company',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
